export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN || "";
export const AUTH0_CIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID || "";
export const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE || "";
export const SERVER_URL = process.env.REACT_APP_SERVER_URL || "";
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || "";
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || "";
